/*
 *   File : basket-listing.js
 *   Author : https://evoqins.com
 *   Description : Basket listing page
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React, { Fragment, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Modal } from 'bootstrap';

// custom components
import { CustomTab, EmptyScreen } from '../../Components/Others';
import { GoalBased, Gold, InstaSave, Thematic } from './Helper';
import { ConfirmRebalanceModal } from '../../Components/Modal';
import { APIService } from '../../Service';
import { PrimaryButton } from '../../Components/Buttons';

const TAB_DATA = [
    { id: 1, label: 'Goal-based' },
    { id: 2, label: 'Thematic' },
    { id: 3, label: 'Insta save' },
    { id: 4, label: 'Gold' },
];

const YEAR_DATA = [
    { id: 1, label: 'Less than 1 year' },
    { id: 2, label: '1-3 years' },
    { id: 3, label: '3-5 years' },
    { id: 4, label: '5-7 years' },
    { id: 5, label: 'More than 7 years' },
];


const BasketListing = () => {

    const navigate = useNavigate();
    const { state } = useLocation();

    const [selectedTab, setSelectedTab] = useState(0);

    const [rebalanceModal, setRebalanceModal] = useState(false);
    const [confirmTrigger, setConfirmTrigger] = useState(false);
    const [basketData, setBasketData] = useState({});
    const [rebalanceData, setRebalanceData] = useState(null);

    const [loader, setLoader] = useState(true);

    const [selectedYear, setSelectedYear] = useState(0);

    const [durationLoader, setDurationLoader] = useState(false);

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        if (state !== null) {
            setSelectedTab(state.tab_index);
            if (state.selected_year) {
                setSelectedYear(state.selected_year);
            } else {
                setSelectedYear(1);
            }
        } else {
            setSelectedTab(1);
            setSelectedYear(1);
        }
    }, [state]);

    useEffect(() => {
        if (selectedTab !== 0) {
            _getBasketList();
        }
    }, [selectedTab, selectedYear]);

    useEffect(() => {
        if (rebalanceModal === true) {
            const rebalance_modal = new Modal(document.getElementById('confirm-rebalance-modal'));
            rebalance_modal.show();
            setConfirmTrigger(false);
        }
    }, [rebalanceModal]);

    // handle tab change
    const _handleTab = (tab_id) => {
        setLoader(true);
        navigate("/baskets", {
            state: {
                tab_index: tab_id,
                selected_year: 1,
            }
        });
    };

    // handle tab select year
    const _handleSelectYear = (tab_id) => {
        setDurationLoader(true);
        navigate("/baskets", {
            state: {
                tab_index: 1,
                selected_year: tab_id
                // duration: state.duration

            }
        });
    };

    // handle trigger re-balance 
    const _handleTriggerRebalance = (row) => {
        console.log('data', row);

        setRebalanceModal(true);
        setRebalanceData(row);
    };

    // handle trigger re-balance 
    const _handleConfirmTrigger = () => {
        setConfirmTrigger(true);
        // setData={}
    };

    // handle navigate create  basket
    const _handleCreateBasket = () => {
        navigate("manage-basket", {
            state: {
                selected_tab: 2,
                edit: false
            }
        });
    };


    // API - Get basket list
    const _getBasketList = () => {
        let is_post = true;
        let url = 'manage-basket/list';
        let request = {
            "investment_type": selectedTab,
            "duration": selectedTab === 1 ? selectedYear : null
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setBasketData(response.data);
            }
            else {
                setBasketData({});
            }
            setLoader(false);
            setDurationLoader(false);
        });
    };

    return (
        <Fragment>
            <section className='e-section-height pb-5' >
                <div className='e-bg-lavender padding-52px-lr pt-2 padding-112px-bottom'>
                    <h3 className='mb-0 e-text-chinese-black e-primary-font e-font-24 e-font-weight-600 line-height-24px'>
                        Manage Baskets
                    </h3>
                </div>

                <div className='padding-52px-lr margin--80px-top'>
                    <div className='e-bg-white border-radius-16 min-vh-50'>
                        <div className='padding-32px-lr padding-32px-tb'>
                            {/* Custom tab */}
                            <CustomTab data={TAB_DATA}
                                selectedTab={selectedTab}
                                tooltip={false}
                                handleClick={_handleTab} />

                            {selectedTab === 2 &&
                                <div className='padding-32px-top text-end'>
                                    <PrimaryButton name="Create New Basket"
                                        paddingBlock="padding-12px-tb"
                                        className="px-4 "
                                        onClick={_handleCreateBasket} />
                                </div>
                            }

                            {loader ?
                                <div className='d-flex align-items-center justify-content-center pt-5'>
                                    <img src={require("../../Assets/Image/loader.gif")}
                                        draggable={false}
                                        width={80}
                                        height={80}
                                        alt='loader'
                                        className='text-center' />
                                </div>
                                :
                                <>
                                    {
                                        selectedTab === 1 ?
                                            <div className='padding-32px-top'>
                                                <CustomTab data={YEAR_DATA}
                                                    selectedTab={selectedYear}
                                                    tooltip={false}
                                                    handleClick={_handleSelectYear} />
                                            </div>
                                        : null
                                }

                                    {Object.keys(basketData).length !== 0 ?
                                        <>
                                            {/* Goal-based */}
                                            {selectedTab === 1 ?
                                                <div className='padding-32px-'>

                                                    {durationLoader ?
                                                        <div className='d-flex align-items-center justify-content-center min-vh-50'>
                                                            <img src={require("../../Assets/Image/loader.gif")}
                                                                draggable={false}
                                                                width={80}
                                                                height={80}
                                                                alt='loader'
                                                                className='text-center' />
                                                        </div>
                                                        :
                                                        <GoalBased basketData={basketData.basket}
                                                            selectedTab={selectedTab}
                                                            duration={selectedYear}
                                                            handleRebalance={_handleTriggerRebalance} />
                                                    }
                                                </div>
                                                :
                                                // Thematic 
                                                selectedTab === 2 ?
                                                    <Thematic basketData={basketData.basket}
                                                        rebalanceData={rebalanceData}
                                                        selectedTab={selectedTab}
                                                        handleRebalance={_handleTriggerRebalance} />
                                                    :
                                                    // Insta Save 
                                                    selectedTab === 3 ?
                                                        <InstaSave basketData={basketData}
                                                            selectedTab={selectedTab}
                                                            rebalanceData={rebalanceData}
                                                            handleRebalance={_handleTriggerRebalance}
                                                        />
                                                        :
                                                        //  Gold 
                                                        selectedTab === 4 ?
                                                            <Gold basketData={basketData}
                                                                selectedTab={selectedTab}
                                                                handleRebalance={_handleTriggerRebalance}
                                                            />
                                                            :
                                                            null
                                            }
                                        </>
                                        :
                                        <EmptyScreen
                                            image={require('../../Assets/Image/NotFound/no-data.png')}
                                            title='No results found'
                                            description={`We couldn't find anything that matches your search. Try checking your spelling, using different keywords, or exploring popular funds.`}
                                        />
                                    }
                                </>
                            }
                        </div>
                    </div>
                </div>
            </section>

            {/* Confirm re-balance modal */}
            {rebalanceModal === true &&
                <ConfirmRebalanceModal rebalanceData={rebalanceData}
                    success={confirmTrigger}
                    handleSuccess={_handleConfirmTrigger}
                    handleClose={() => {
                        setTimeout(() => {
                            setRebalanceModal(false);
                            setRebalanceData(null)
                        }, 200);
                    }} />
            }
        </Fragment>
    )
}

export default BasketListing
